export default "__VITE_ASSET__S1_twFtW__"